module.exports = __webpack_public_path__ + "static/safeentry-logo-72ab1ad11bc33652e18322c04d16a7b5.svg";